// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WMHp2","toggle":"styles_toggle__3rMsl","preview":"styles_preview__25aCC"};